import React from "react";
import { Box, DraggableTr, Flex, Icon, TableIconButton, Td, Text, useTranslation } from "@familyzone/component-library";

import { DeleteButtonNew } from "../../../modules/DeleteButtonNew";

import { SafeSearchRule } from "../types";
import { UserFriendlyGroupsCriteriaPrinter } from "../../../modules/criteria/UserFriendlyGroupsCriteriaPrinter";

export const googleEnabledText = "SafeSearch Enforced";
export const googleDisabledText = "SafeSearch Disabled";
export const ytEnabledText = "Strict SafeSearch";
export const ytDisabledText = "SafeSearch Disabled";
export const ytModerateText = "Moderate SafeSearch";
export const bingDisabledText = "SafeSearch Disabled";
export const bingEnabledText = "SafeSearch Enforced";

interface SafeSearchTableRowProps {
  rule: SafeSearchRule;
  id: string;
  disabled?: boolean;
  onEdit: (e: React.SyntheticEvent) => void;
  onDelete: () => void;
}

const SafeSearchTableRow: React.FC<SafeSearchTableRowProps> = ({ rule, id, disabled = false, onEdit = () => "", onDelete = () => "" }) => {
  const { t } = useTranslation();

  return (
    <DraggableTr id={id} backgroundColor="neutrals.0">
      <Td width="48px">
        <Box p="sp4" display="flex" justifyContent="center">
          <Icon icon="fa-ellipsis-vertical" variant="solid" color="text.paragraph.light" boxSize="14px" />
        </Box>
      </Td>
      <Td>
        <Text>
          <UserFriendlyGroupsCriteriaPrinter criteria={rule.source_criteria} />
        </Text>
      </Td>
      <Td>
        <Text>{rule.enabled ? t(googleEnabledText) : t(googleDisabledText)}</Text>
      </Td>
      <Td>
        <Text>{rule.youtube_moderate_enabled ? t(ytModerateText) : rule.youtube_enabled ? t(ytEnabledText) : t(ytDisabledText)}</Text>
      </Td>
      <Td>
        <Text>{rule.bing_enabled ? t(bingEnabledText) : t(bingDisabledText)}</Text>
      </Td>
      <Td>
        <Flex justifyContent="end">
          <Box mr="sp8">
            <TableIconButton
              data-testid={`${rule.id}-edit`}
              icon={<Icon icon="fa-pencil" variant="solid" color="text.paragraph.light" />}
              aria-label="Edit"
              onClick={onEdit}
              disabled={disabled}
            />
          </Box>
          <DeleteButtonNew data-testid={`${rule.id}-delete`} disabled={disabled} onClick={onDelete} />
        </Flex>
      </Td>
    </DraggableTr>
  );
};

export default SafeSearchTableRow;
